<template>
  <div>
    <el-collapse v-model="collapseActiveName" v-if="list && list.length">
      <el-collapse-item title="危险源辨识" :name="'identify'">
        <el-table max-height="400px" :data="list" border class="w-full" stripe>
          <template v-if="isEquip">
            <el-table-column
              label="检查项目"
              prop="projectName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="检查标准"
              prop="standard"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="不符合标准情况"
              prop="noComplianceStandard"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="主要后果"
              prop="consequences"
              show-overflow-tooltip
            ></el-table-column>
          </template>

          <template v-else>
            <el-table-column
              label="作业步骤"
              prop="jobStep"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="检查标准"
              prop="hiddenEvent"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="危险有害因素分类"
              prop="harmElementType"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="可能导致的事故类型"
              prop="accidentType"
              show-overflow-tooltip
            ></el-table-column>
          </template>

          <el-table-column label="LS评估方法" prop="riskRatingMethodLS" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                !scope.row.riskRatingMethodLS && scope.row.riskRatingMethodLEC
                  ? '/'
                  : scope.row.riskRatingMethodLS
              }}
            </template>
          </el-table-column>
          <el-table-column label="LEC评估方法" prop="riskRatingMethodLEC" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                !scope.row.riskRatingMethodLEC && scope.row.riskRatingMethodLS
                  ? '/'
                  : scope.row.riskRatingMethodLEC
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="D/R风险值"
            prop="dRiskValue"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="评价级别"
            prop="evaluationLevel"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-model="collapseActiveName" v-for="(item, index) in list" :key="index">
      <el-collapse-item :title="`管控措施${index + 1}`" :name="'control' + index">
        <ControlMeasure
          :identifyId="
            item.equipmentFacilitySourcesDangerIdentifyId || item.jobSourcesDangerIdentifyId
          "
          :disabled="true"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import ControlMeasure from './ControlMeasure'

export default {
  name: 'bank-collapse-list',
  components: {
    ControlMeasure,
  },
  props: {
    list: {
      default: () => {
        return []
      },
    },
    evaluateMethod: {
      default: 0,
      type: Number,
    },
    isEquip: {
      default: true,
    },
  },
  data() {
    return {
      collapseActiveName: [],
      taskList: [1, 2],
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-collapse {
  border-top: 0px;
}
</style>
